'use client';

import React from 'react';
import { PetsFilters } from '../../../BookingJourney/components/landing/hero/filters/PetsFilters';
export const PetsSearchField: React.FC = () => {
  return <div className="w-full" data-sentry-component="PetsSearchField" data-sentry-source-file="PetsSearchField.tsx">
      <PetsFilters containerClass="w-full" triggerButtonClass="border-none bg-transparent md:pl-0 pr-1" titleClassName='hidden' fullWidthAll={true} dateCaptionClassName="text-[13px] font-new-hero mt-[2px]" data-sentry-element="PetsFilters" data-sentry-source-file="PetsSearchField.tsx" />
    </div>;
};
export default PetsSearchField;